/* eslint-disable prefer-const */
import { Component, Inject, OnInit } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import {
  ActivatedRoute,
  // NavigationEnd,
  NavigationStart,
  Router,
} from '@angular/router';
import { Subscription } from 'rxjs';
import { CommonService } from 'src/@services/common.service';
import { AccessControlService } from 'src/@services/access-control.service';
import { CommonPagesService } from 'src/@shared/shared/common-pages.service';
import {
  responseMessageStatus,
  ResponseStatus,
  RoleType,
} from 'src/@shared/shared/enum';
import {
  LOCAL_STORAGE_PORT,
  SESSION_STORAGE_PORT,
  StoragePort,
} from 'src/@shared/shared/providers';
import { Program } from 'src/models/program.model';
import { InnerPagesService } from '../inner-pages.service';
import { AuthGuard } from 'src/@shared/shared/auth.guard';
import { AccountSection } from '../account-settings/shared/account-sidebar.component';
import { isPhoneVerificationRequired, DeviceIdService, isMfaPending, MfaChallengeStore, PhoneVerificationStore } from 'src/@shared/auth';
declare const jQuery: any;

@Component({
  selector: 'app-common-layout',
  templateUrl: './common-layout.component.html',
  styleUrls: ['./common-layout.component.scss', '../account-settings/account-layout.scss'],
  standalone: false,
})
export class CommonLayoutComponent implements OnInit {
  //#region properties
  currentUrl: string;
  isVisibleSwitchAccountModal: boolean = false;
  canViewSummary: boolean = false;
  canViewActivity: boolean = false;
  canViewInvestments: boolean = false;
  canAddPayment: boolean = false;
  canViewInvestors: boolean = false;
  canViewVendors: boolean = false;
  canViewProgramsTags: boolean = false;
  canViewTags: boolean = false;
  canViewUsers: boolean = false;
  canViewNotifications: boolean = false;
  canViewTutorials: boolean = false;
  canViewReports: boolean = false;
  canViewProjections: boolean = false;
  canViewAccountStatements: boolean = false;
  canViewActivityExport: boolean = false;
  canViewOutstandingStatement: boolean = false;
  canViewInternalReportsModule: boolean = false;
  reportsLandingPath: string = 'report-account-statements';
  siteId: string;
  settingUrl: string = '';
  hasSettingsPage: boolean = false;
  userInfo: any;
  bearerToken: string | null = null;
  userRoleDetails: any;
  agencyDetails: any;
  siteDetails: any;
  siteLogo: string;
  isVisibleAnnouncements: boolean = false;
  isInternalRoleUser: boolean = false;
  siteName: string = '';
  listOfPrograms: Program[] = [];
  listOfTags: any[] = [];
  subscriptions: Subscription[] = [];
  notificationsCount: number = 0;
  numberOfSeconds: number = 5;
  isVisibleMenu: boolean = false;
  sessionAgencyDetails: any;
  listOfAllocatedSites: any[] = [];
  currentYear: any = new Date().getFullYear();
  sitesCount: number = 0;
  supplierCount: number = 0;
  supplierBankSitesCount: number = 0;
  listOfAccounts: any[];
  listOfSuppliers: any[];
  listOfSupplierBanks: any[];
  listOfSites: any[];
  listOfSBSites: any[];
  //#endregion

  /** Header logo target: the first page this role can open (usually Summary). */
  homeUrl = '';

  constructor(
    public _cS: CommonService,
    private _router: Router,
    private _iS: InnerPagesService,
    private route: ActivatedRoute,
    private _cpS: CommonPagesService,
    private accessControlService: AccessControlService,
    private authGuard: AuthGuard,
    @Inject(LOCAL_STORAGE_PORT) private localStoragePort: StoragePort,
    @Inject(SESSION_STORAGE_PORT) private sessionStoragePort: StoragePort,
    @Inject(DOCUMENT) private doc: Document,
    private deviceId: DeviceIdService,
    private mfaChallengeStore: MfaChallengeStore,
    private phoneVerificationStore: PhoneVerificationStore
  ) {
    this.userInfo = JSON.parse(this.localStoragePort.getItem('UserInfo') || '{}');
    this.bearerToken = this.localStoragePort.getItem('BearerToken');
    this.userRoleDetails = JSON.parse(
      this.localStoragePort.getItem('UserRoleDetails') || '{}'
    );
    this.sessionAgencyDetails = JSON.parse(
      this.sessionStoragePort.getItem('AgencyDetails') || '{}'
    );
    this.listOfAllocatedSites = JSON.parse(
      this.localStoragePort.getItem('AllocatedSites') || '[]'
    );
    this.sitesCount = this.localStoragePort.getItem('listOfAccounts')
      ? Number(JSON.parse(this.localStoragePort.getItem('listOfAccounts') || '0'))
      : 0;
    this.supplierCount = this.localStoragePort.getItem('listOfSuppliers')
      ? Number(JSON.parse(this.localStoragePort.getItem('listOfSuppliers') || '0'))
      : 0;
    this.supplierBankSitesCount = this.localStoragePort.getItem('listOfSupplierBanks')
      ? Number(JSON.parse(this.localStoragePort.getItem('listOfSupplierBanks') || '0'))
      : 0;

    this.siteId = this.route.snapshot.paramMap.get('siteId');
    if (this.userInfo) {
      this._cS.on('NewAnnouncement', (notifications: any) => {
        if (notifications) {
          const currentUser = notifications.find(
            (x: any) => x.userId == this.userInfo.userId
          );
          const totalAnouncements = currentUser.announcements;
          const toShowNotificatioons = totalAnouncements.find(
            (x: any) => x.siteId == this.siteId
          );
          this.notificationsCount = toShowNotificatioons.count;
        }
      });
    }
    const authenticateUser = this.doc.location.href.split('?t=')[1];
    if (authenticateUser && this.bearerToken == null) {
      this.currentUrl = this._router.url;
      this.route.queryParams.subscribe((params) => {
        if (params) {
          let email = params['e'];
          let rToken = params['t'];
          let supplierToken = params['st'];
          const isRetailRequest = params['isRetailRequest'] === 'true' || params['isRetailRequest'] === true;
          if (supplierToken) {
            this.localStoragePort.setItem('SupplierBearerToken', supplierToken);
          }
          if (email && rToken) {
            email = email.replace('=', '');
            rToken = rToken.replace('=', '');
            const formData = new FormData();
            formData.set('email', email);
            if (isRetailRequest) {
              formData.set('bearerToken', rToken);
            } else {
              formData.set('token', rToken);
            }
            formData.set('environment', 'PAYBEV');
            this._cS.isAutoLoginInProgress = true;
            formData.set('deviceFingerprint', this.deviceId.getOrCreate());
            this._cS.paybevAutoLogin(formData).subscribe({ error: () => this.onAutoLoginFailed(false), next: (response: any) => {
              this._cS.isAutoLoginInProgress = false;
              if (response.responseStatus != ResponseStatus.success) {
                this.onAutoLoginFailed(true);
                return;
              }
              const ssoResult = response?.result;
              if (response.responseStatus == ResponseStatus.success && ssoResult && isMfaPending(ssoResult)) {
                // New portal on a device it has not seen: second factor first, then verify-user lands the user.
                this.mfaChallengeStore.set({
                  challengeId: ssoResult.challengeId,
                  email: decodeURIComponent(escape(atob(email))),
                  channels: ssoResult.channels,
                  maskedPhone: ssoResult.maskedPhone,
                  maskedEmail: ssoResult.maskedEmail,
                  sent: ssoResult.sent,
                  sendMessage: ssoResult.sendMessage,
                });
                this._router.navigate(['/verify-user']);
                return;
              }
              if (response.responseStatus == ResponseStatus.success && ssoResult && isPhoneVerificationRequired(ssoResult)) {
                this.phoneVerificationStore.set(ssoResult);
                this._router.navigate(['/mobile-verify']);
                return;
              }
              if (response.responseStatus != ResponseStatus.success) {
                this._cS.displayMessage(responseMessageStatus.error, response.message || 'Sign-in handoff failed. Please sign in.');
                this._router.navigate(['/login']);
                return;
              }
              if (response.responseStatus == ResponseStatus.success) {
                const usersDetails = response.result.userdetails;
                const userInfo = {
                  firstName: usersDetails.firstName,
                  lastName: usersDetails.lastName,
                  userId: usersDetails.id,
                  phoneNumber: usersDetails.phoneNumber,
                  agency: usersDetails.agency,
                  twoFactorEnabled: usersDetails.twoFactorEnabled,
                  isForcePasswordChange: usersDetails.isForcePasswordChange,
                  email: usersDetails.email,
                  localSupplier: usersDetails.localSupplier,
                  suppliers: usersDetails.suppliers,
                  supplierBankSitesData: usersDetails.supplierBankSitesData
                };
                _cS.userInfoHeader.next(userInfo);
                this.localStoragePort.setItem(
                  'BearerToken',
                  response.result.access_token
                );
                this.localStoragePort.setItem(
                  'RefreshToken',
                  response.result.refreshToken
                );
                this.localStoragePort.setItem(
                  'UserRole',
                  response.result.userRoleDetails.name
                );
                this.localStoragePort.setItem(
                  'UserRoleDetails',
                  JSON.stringify(response.result.userRoleDetails)
                );
                this.localStoragePort.setItem('UserInfo', JSON.stringify(userInfo));
                const PayBevModulesPermissions =
                  response.result.userRoleDetails.permissions.filter(
                    (x: any) => x.moduleType == 'Paybev'
                  );

                const SupplierModulesPermissions =
                  response.result.userRoleDetails.permissions.filter(
                    (x: any) => x.moduleType == 'Supplier'
                  );

                this.localStoragePort.setItem(
                  'RolePermissions',
                  JSON.stringify(PayBevModulesPermissions)
                );
                this.localStoragePort.setItem(
                  'SupplierRolePermissions',
                  JSON.stringify(SupplierModulesPermissions)
                );

                this.listOfAccounts = [...response.result?.operator || []];
                this.listOfSuppliers = [...usersDetails?.suppliers || []];
                this.listOfSupplierBanks = [...response.result?.supplierBank || []];

                this.listOfSites = this.listOfAccounts.flatMap((account: any) => account.Sites || []);
                //fetch sites from all supplierBank accounts
                const supplierBankSites = this.listOfSupplierBanks.flatMap((account: any) => account.Sites || []);
                //merge sites from operator accounts and supplierBank accounts
                this.listOfSBSites = supplierBankSites;

                this.supplierCount = usersDetails.suppliers?.length || 0;
                this.sitesCount = this.listOfSites?.length || 0;
                this.supplierBankSitesCount = this.listOfSBSites?.length || 0;


                this.localStoragePort.setItem(
                  'listOfAccounts',
                  JSON.stringify(this.listOfSites?.length || 0)
                );
                this.localStoragePort.setItem(
                  'listOfSuppliers',
                  JSON.stringify(usersDetails.suppliers?.length || 0)
                );
                this.localStoragePort.setItem(
                  'listOfSupplierBanks',
                  JSON.stringify(this.listOfSBSites?.length || 0)
                );


                this.localStoragePort.setItem('IsSiteSelected', JSON.stringify(true));
                this.checkPermissions();
                this.getSiteAgencyDetails();
                // Announce the session only once the move has settled: a page this role cannot
                // view would otherwise load its data and be signed out by the 401 that comes back.
                const sessionReady = () => this._cS.fetchDataAfterAutoLogin.next(true);
                this.landOnPermittedPage().then(sessionReady, sessionReady);
              }
            }});
          }
        }
      });
    } else {
      this.checkPermissions();
    }
  }
  previousUrl: string = '';

  /**
   * Drop the hand-off query string, and move off the requested page when this role cannot open
   * it. The guard could not judge it on the way in - there was no token yet - so a link naming a
   * page the role has no permission for, or a page PayBev does not serve, is only caught here.
   *
   * Resolves once the move has settled, so the caller can wait before announcing the session.
   */
  private landOnPermittedPage(): Promise<boolean> {
    const base = `/paybev/${this.siteId}`;
    if (this.siteId && !this.authGuard.isUrlPermitted(this._router.url, this.siteId)) {
      return this._router.navigateByUrl(this.authGuard.getLandingUrl(base));
    }

    return this._router.navigate([], {
      queryParams: {
        t: null,
        e: null,
        isRetailRequest: null,
      },
      queryParamsHandling: 'merge',
    });
  }

  /**
   * SsoLogin hand-off failed. HTTP errors are already routed through
   * CommonService.errorHandling; a 200 with ResponseStatus.Error is not,
   * so end the half-open session here instead of leaving the page tokenless.
   */
  private onAutoLoginFailed(isBusinessError: boolean): void {
    this._cS.isAutoLoginInProgress = false;
    if (!isBusinessError) {
      return;
    }
    this._cS.displayMessage('warning', 'Your session could not be started. Please log in again.');
    this._cS.logOut();
  }

  //#region functions
  /** User Profile + Security screens: full-bleed content so the mint panel can match the sider height. */
  get isAccountSettingsView(): boolean {
    const url = this.currentUrl || '';
    return url.includes('/user-profile/') || url.includes('/security/');
  }

  /** Which account menu the mobile drawer shows on the User Profile / Security screens. */
  get accountSection(): AccountSection {
    return (this.currentUrl || '').includes('/security/') ? 'security' : 'profile';
  }

  ngOnInit(): void {
    //get current site details and update site accordingly
    this.siteId = this.route.snapshot.paramMap.get('siteId');

    this.setAgencyColorLogo();

    this.currentUrl = this._router.url;
    this.previousUrl = null;

    // Listen to router events to track navigation
    this._router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        // Update previous URL and set current URL to the new one
        this.previousUrl = this._cS.previousURL = this.currentUrl;
        this.currentUrl = this._cS.currentURL = event.url;
        this.sessionStoragePort.setItem('previousURL', this.previousUrl);
        this.sessionStoragePort.setItem('currentURL', this.currentUrl);
      }
    });
    //get current url
    // this.currentUrl = this._router.url;
    // this.previousUrl = null;
    // this._router.events.subscribe((event: any) => {
    //   if (event instanceof NavigationEnd) {
    //     this.currentUrl = event.url;

    //   }
    // });
    this.subscriptions.push(
      this._cS.programsListObserver.subscribe((res: any) => {
        if (res) {
          this.loadPrograms();
        }
      }),
      this._cS.tagsObserver.subscribe((res: any) => {
        if (res) {
          this.getTags();
        }
      }),
      this._cS.userInfoHeader.subscribe((res: any) => {
        if (res) {
          this.userInfo.firstName = res.firstName;
          this.userInfo.lastName = res.lastName;
          this.userInfo.phoneNumber = res.phoneNumber;
        }
      }),
      this._cS.updateSiteDetails.subscribe((value) => {
        if (value) {
          this.getSiteAgencyDetails();
        }
      })
    );
    setTimeout(() => {
      this.getAnnouncements();
    }, 1000);

    if (this.bearerToken && this.siteId) {
      this.getSiteAgencyDetails();
    }

    this.isInternalRoleUser = Number(this.userRoleDetails?.roleType) === RoleType.Internal
  }
  logout() {
    // Remove query params
    this._router.navigate([], {
      queryParams: {
        t: null,
        e: null,
        pt: null,
      },
      queryParamsHandling: 'merge',
    });
    this._cS.hubConnection.stop();
    // Sign out locally whether or not the API call succeeds; a failed revoke must never keep the user signed in.
    this._iS.logOut().subscribe({
      next: () => this._cS.logOut(),
      error: () => this._cS.logOut(),
    });

    // if (supplierBearerToken) {
    //   this._iS.logOut2(supplierBearerToken).subscribe(() => {
    //     this._cS.logOut();
    //   });
    // }
  }
  getAnnouncements() {
    this._iS.getAnnouncements(this.siteId).subscribe((response: any) => {
      if (response.responseStatus == ResponseStatus.success) {
        this.notificationsCount = response.result.length;
      } else {
        this._cS.displayMessage(responseMessageStatus.error, response.message);
      }
    });
  }
  //load program periods
  loadPrograms() {
    this._cS.isLoadingPrograms = true;
    this._cpS.getProgramBySite().subscribe((response: any) => {
      if (response.responseStatus == ResponseStatus.success) {
        this.listOfPrograms = response.result;
        this._cS.listOfProgramPeriods.next(this.listOfPrograms);
        this._cS.isLoadingPrograms = false;
      } else {
        this.listOfPrograms = [];
        this._cS.displayMessage(responseMessageStatus.error, response.message);
        this._cS.isLoadingPrograms = false;
      }
    });
  }
  checkPermissions() {
    this.canViewSummary = this.accessControlService.canAccessSummary().canViewSummary;
    this.canViewActivity = this.accessControlService.canAccessActivity().canViewActivity;
    this.canViewInvestments = this.accessControlService.canAccessInvestments().canViewInvestments;
    this.canAddPayment = this.accessControlService.canAccessPayments().canAddPayment;
    this.canViewInvestors = this.accessControlService.canAccessInvestors().canViewInvestors;
    this.canViewVendors = this.accessControlService.canAccessVendors().canViewVendors;
    this.canViewProgramsTags = this.accessControlService.canAccessProgramsTags().canViewProgramsTags;
    this.canViewTags = this.accessControlService.canAccessTags().canViewTags;
    this.canViewUsers = this.accessControlService.canAccessUsers().canViewUsers;
    this.canViewNotifications = this.accessControlService.canAccessNotifications().canViewNotifications;
    this.canViewTutorials = this.accessControlService.canAccessTutorials();
    this.canViewReports = this.accessControlService.canAccessReports();
    this.canViewProjections = this.accessControlService.canViewProjections();
    this.canViewAccountStatements =
      this.accessControlService.canViewAccountStatements();
    this.canViewActivityExport =
      this.accessControlService.canViewActivityExport();
    this.canViewOutstandingStatement =
      this.accessControlService.canViewOutstandingStatement();
    this.canViewInternalReportsModule =
      this.accessControlService.canViewInternalReports();
    this.reportsLandingPath =
      this.accessControlService.getFirstReportsLandingPath();

    this.setSettingUrl();
  }
  // The gear shows only when this role can open at least one Settings page on this site.
  // Re-run once this site's details load: Program Periods and Tags depend on its visibility switches.
  setSettingUrl() {
    const siteDetails = this.getCurrentSiteDetails();
    // Until this site's details are known, Program Periods and Tags count as unavailable.
    const IsSiteProgramPeriodVisible = !!siteDetails && siteDetails.IsProgramPeriodVisible !== false;
    const IsSiteTagVisible = !!siteDetails && siteDetails.IsTagVisible !== false;

    // Tutorials is not listed: its page and route are removed.
    const allowedPages = [
      { permission: this.canViewInvestors, url: '/investors' },
      { permission: this.canViewVendors, url: '/vendors' },
      {
        permission: this.canViewProgramsTags && IsSiteProgramPeriodVisible,
        url: '/program-periods',
      },
      {
        permission: this.canViewTags && IsSiteTagVisible,
        url: '/tags',
      },
      { permission: this.canViewUsers, url: '/users' },
      { permission: this.canViewNotifications, url: '/notifications' },
    ];

    //find the first record from allowed pages which has permission set to true and extract its url
    const allowedPage = allowedPages.find((obj) => obj.permission == true);
    this.hasSettingsPage = !!allowedPage;
    if (allowedPage) {
      this.settingUrl = '/paybev/' + this.siteId + allowedPage.url;
    } else {
      this.settingUrl = '/paybev/' + this.siteId + '/investors';
    }
    this.homeUrl = this.authGuard.getLandingUrl('/paybev/' + this.siteId);
  }
  // The loaded response wins; session storage is used only if it belongs to this site.
  private getCurrentSiteDetails(): any {
    if (this.siteDetails) {
      return this.siteDetails;
    }
    const stored = JSON.parse(this.sessionStoragePort.getItem('SiteDetails') || 'null');
    return stored && stored._id == this.siteId ? stored : null;
  }
  getSiteAgencyDetails() {
    this._iS.getSiteAgencyDetails(this.siteId).subscribe((response: any) => {
      if (response) {
        if (response.responseStatus == ResponseStatus.success) {
          this.agencyDetails = response.result.agencyDetails;
          this.siteDetails = response.result.siteDetails;
          this.siteName = this._iS.siteName = this.siteDetails.Name;
          // if((!this.siteDetails.IsProgramPeriodVisible && this.currentUrl.includes('program-periods')) || (!this.siteDetails.IsTagVisible && this.currentUrl.includes('tags'))){
          //   this._router.navigate(['page-not-found'])
          //  }
          this._cS.agencySiteDetails.next(this.siteDetails);
          this.sessionStoragePort.setItem(
            'AgencyDetails',
            JSON.stringify(this.agencyDetails)
          );
          this.sessionStoragePort.setItem(
            'SiteDetails',
            JSON.stringify(this.siteDetails)
          );
          this.setSettingUrl();
          this.sessionStoragePort.setItem('CurrentSite', this.siteDetails._id);
          this.sessionAgencyDetails = this.agencyDetails;
          this.setAgencyColorLogo();
        } else {
          this._cS.displayMessage(
            responseMessageStatus.error,
            response.message
          );
        }
      } else {
        this._cS.redirectToSwitchAccount();
      }
    });
  }
  getTags() {
    this._cS.isLoadingTags = true;
    setTimeout(() => {
      this._iS.getTagsDropdownList(this.siteId).subscribe((response: any) => {
        if (response.responseStatus == ResponseStatus.success) {
          this.listOfTags = response.result;
          this._cS.listOfTags.next(this.listOfTags);
          this._cS.isLoadingTags = false;
        } else {
          this.listOfTags = [];
          this._cS.isLoadingTags = false;
        }
      });
    }, 1000);
  }
  showAnnouncemnts() {
    this.isVisibleAnnouncements = true;
  }

  setAgencyColorLogo() {
    if (this.sessionAgencyDetails?.DarkColor) {
      this.doc.documentElement.style.setProperty(
        '--theme-color',
        this.sessionAgencyDetails?.DarkColor
      );
    }
    this.doc.documentElement.style.setProperty(
      '--light-color',
      this.sessionAgencyDetails?.LightColor
    );
    this.siteLogo = this.sessionAgencyDetails?.Profile;
  }

  showSwitchAccountModal() {
    this.isVisibleSwitchAccountModal = true;
  }
  hideSwitchAccountModal() {
    this.isVisibleSwitchAccountModal = false;
  }
  hideAnnouncements(event: any) {
    this.isVisibleAnnouncements = event.visible;
    this.notificationsCount = event.notifications;
  }
  handleCancelisVisibleMenu() {
    this.isVisibleMenu = false;
  }
  removeClass() {
    jQuery('body').removeClass('active-menu');
  }
  ngOnDestroy(): void {
    this.subscriptions.map((s) => s.unsubscribe());
  }
  //#endregion
}
